import React from 'react';
import styled from 'styled-components';
import { Grid, Type } from '../../../app/StyleGuide';
import { Card, CardPoster, InlineList } from '../../../components/Layout';
import TrainingPosterPlaceholder from './TrainingPosterPlaceholder';
import { IconBadge } from '../../../components/Badge';
import capitalizeFilter from '../../../filters/capitalize-filter';
import WhiteLabel from '../../../filters/WhiteLabel';
import trainingService from '../../../services/trainingService';
import { useOrg } from '../../org';
import { getNumTrainingItemsText } from '../utils/getNumTrainingItemsText';
import { TrainingItem } from '../../catalog/models/trainingItem';

const Details = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${Grid._4};
  text-transform: capitalize;
  color: ${Type.Color.dark};
  h4 {
    margin: 0 0 ${Grid._4} 0;
    font-weight: ${Type.Weight.semibold};
  }
  span {
    position: absolute;
    top: -25px;
    right: 25px;
  }
`;

export default function TrainingCard({
  training,
  redirectToTraining,
  canRedirect = true,
}: {
  training: TrainingItem;
  redirectToTraining: (id: string) => void;
  canRedirect?: boolean;
}) {
  const { org } = useOrg();
  const isOrgOwned = !!org && org.id === training.ownerId;
  return (
    <Card
      data-qa-hook="trainingItem"
      style={{ flexDirection: 'column' }}
      onClick={() => redirectToTraining(training.id)}
      className={canRedirect ? '' : 'disabled'}
    >
      {training.image ? (
        <CardPoster src={trainingService.getTrainingImageUrl(training.image)} alt={training.name} />
      ) : (
        <TrainingPosterPlaceholder ownerName={isOrgOwned ? org.name : WhiteLabel.name} />
      )}
      <Details>
        {training._type.toLowerCase() === 'pathway' && (
          <IconBadge className="icon-badge">
            <i className="fas fa-route"></i>
          </IconBadge>
        )}
        <h4
          data-qa-hook="trainingName"
          style={{ paddingRight: training._type.toLowerCase() === 'pathway' ? `${Grid._11}` : '0' }}
        >
          {training.name}
        </h4>
        <InlineList content="•" fontSize="16px">
          <li>
            {training._type.toLowerCase() === 'course'
              ? capitalizeFilter(WhiteLabel.labels.course)
              : capitalizeFilter(WhiteLabel.labels.pathway)}
          </li>
          <li>{getNumTrainingItemsText(training)}</li>
        </InlineList>
      </Details>
    </Card>
  );
}
